export interface BuyerInterface {
    fullName: string,
    id: string,
    email: string,
    mobileNo?: string,
    mobileNoVerified: boolean,
    chatToken: string,
    createdAt: string,
    profileImage?: string,
    profileImageAssetId?: string,
    about: string | undefined
}

interface FavouriteItem {
    gig: string
}

export class Buyer implements BuyerInterface {
    fullName: string = "";
    id: string = "";
    email: string = "";
    mobileNo?: string | undefined = undefined;
    mobileNoVerified: boolean = false;
    chatToken: string = "";
    seller: string | undefined;
    profileImage?: string;
    profileImageAssetId?: string;
    createdAt: string = "";
    about: string | undefined = undefined;
    favourites: FavouriteItem[] = [];
    
    // constructor overloads
    public constructor();
    public constructor(jsonData: any);

    public constructor(...paramsArray: any[]) {
        // constructor with no parameters passed will let create a default instance
        if (paramsArray.length === 0) {

        }

        // constructor with 1 parameter passed will decode the json into the class object
        if (paramsArray.length === 1) {
            let jsonData = paramsArray[0];

            this.fullName = jsonData.fullName
            this.id = jsonData._id
            this.email = jsonData.email
            this.mobileNo = jsonData.mobileNo
            this.mobileNoVerified = jsonData.mobileNoVerified
            this.chatToken = jsonData.chatToken
            this.createdAt = jsonData.createdAt
            this.profileImage = jsonData.profileImage
            this.profileImageAssetId = jsonData.profileImageAssetId
            this.about = jsonData.about
            this.seller = jsonData.seller
            this.favourites = jsonData.favourites
        }

    }
}